import React from 'react';
import { InputField } from 'vindi-ds-components';

function CustomerPhoneField() {
  return (
    <InputField placeholder='(XX) XXXXX-XXXX' label='Telefone' mask='cell' name='phone' />
  );
}

export default CustomerPhoneField;
